import React from "react";
import styled from "styled-components";
import { colorMain, maxMobile } from "../styles";
// import { kebabCase } from "lodash";

const Wrapper = styled.div`
  padding: 12px 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;
const Title = styled.h5`
  margin: 8px 16px 8px 0;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 133%;
  letter-spacing: -0.014em;
  color: ${colorMain};
`;
const Tag = styled.span`
  margin: 8px 8px;
  padding: 8px 16px;
  background: #ffffff;
  border-radius: 51px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 171%;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.006em;
  color: ${colorMain};
  text-transform: capitalize;

  @media (${maxMobile}) {
    font-size: 16px;
  }
`;

const Tags = ({ tags }) => {
  return (
    <Wrapper className="tags-wrapper">
      <Title className="title">Tags:</Title>
      {tags.map((tag) => (
        <Tag className="tag" key={tag + `tag`}>
          {tag}
        </Tag>
      ))}
    </Wrapper>
  );
};

export default Tags;
